import React, { useState } from 'react';

interface CheckboxOption {
  label: string;
  value: string;
}

interface CheckboxFieldProps {
  options: CheckboxOption[];
  onChange: (values: string[]) => void;
}

const CheckboxField: React.FC<CheckboxFieldProps> = ({ options, onChange }) => {
  const [selectedValues, setSelectedValues] = useState<string[]>([]);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const isChecked = event.target.checked;
    let updatedValues: string[];

    if (isChecked) {
      updatedValues = [...selectedValues, value];
    } else {
      updatedValues = selectedValues.filter((val) => val !== value);
    }

    setSelectedValues(updatedValues);
    onChange(updatedValues);
  };

  return (
    <div className='custom-check-box-group'>
      {options.map((option, index) => (
        <div key={index}>
          <input
            type="checkbox"
            id={option.value}
            name={option.value}
            value={option.value}
            checked={selectedValues.includes(option.value)}
            onChange={handleCheckboxChange}
          />
          <label htmlFor={option.value}>{option.label}</label>
        </div>
      ))}
    </div>
  );
};

export default CheckboxField;
